'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { type UseSalsifyContentProps, useSalsifyContent } from './use-salsify-content';
import { useWebcollage } from './use-webcollage';
export type UseSalsifyProps = UseSalsifyContentProps;
export function useSalsify(t0) {
  const $ = _c(8);
  const {
    salsifyClientId,
    salsifyIdType,
    productId
  } = t0;
  let t1;
  if ($[0] !== productId || $[1] !== salsifyClientId || $[2] !== salsifyIdType) {
    t1 = {
      productId,
      salsifyClientId,
      salsifyIdType
    };
    $[0] = productId;
    $[1] = salsifyClientId;
    $[2] = salsifyIdType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const salsifyFound = useSalsifyContent(t1);
  const {
    initializeWebcollage,
    webCollageFound
  } = useWebcollage(productId);
  let t2;
  if ($[4] !== initializeWebcollage || $[5] !== salsifyFound || $[6] !== webCollageFound) {
    t2 = {
      initializeWebcollage,
      webCollageFound,
      salsifyFound
    };
    $[4] = initializeWebcollage;
    $[5] = salsifyFound;
    $[6] = webCollageFound;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}